import { agentFetcher } from '@/api/base/agentFetcher'

export interface WorkspaceLicenseItem {
  flavorId: string
  flavorDisplayName: string
  activatedCount: number
  maxDevices: number
  initTokens: number
  ableTokens: number
  usedTokens: number
  expiresAt: number | null
}

export interface WorkspaceCodeItem {
  id: number
  code: string
  status: number          // 0=未使用 1=已使用
  usedAndroidId: string | null
  usedAt: string | null
  createTime: string
}

export interface CodePageResult {
  total: number
  page: number
  pageSize: number
  items: WorkspaceCodeItem[]
}

export const workspaceAppService = {
  getLicenses: (workspaceId: number) =>
    agentFetcher.get<WorkspaceLicenseItem[]>('/user/workspace/licenses', { workspaceId }),

  getCodes: (workspaceId: number, flavorId: string, page = 1, pageSize = 20) =>
    agentFetcher.get<CodePageResult>('/user/workspace/codes', {
      workspaceId,
      flavorId,
      page,
      pageSize,
    }),
}
